module.exports = __webpack_public_path__ + "static/media/ZT6.de618951.jpg";